import React from 'react';
import { BACK_BTN_LABEL, FormBuilder, SUBMIT_BTN_LABEL } from 'commons-ui';

import { EDIT_FORM_FIELD_CONFIG, VIEW_FORM_LAYOUT_CONFIG } from '../../formConfig';

import useView from './useView';

const EditSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useView();
	return (
		<FormBuilder
			data={data}
			mode='view'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={EDIT_FORM_FIELD_CONFIG}
			layoutConfig={VIEW_FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: BACK_BTN_LABEL, submitLabel: SUBMIT_BTN_LABEL }}
		/>
	);
};

export default EditSegment;
